export const isValidHttpUrl = (value: string) => {
  if (!value.trim()) return false;

  try {
    const url = new URL(value.trim());

    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const isValidVideoUrl = (value: string) => {
  if (!isValidHttpUrl(value)) return false;

  const url = new URL(value.trim());
  const host = url.hostname.toLowerCase();
  const path = url.pathname.toLowerCase();

  const knownVideoHosts = [
    "youtube.com",
    "www.youtube.com",
    "youtu.be",
    "vimeo.com",
    "www.vimeo.com",
    "loom.com",
    "www.loom.com",
    "dailymotion.com",
    "www.dailymotion.com",
    "drive.google.com",
    "wistia.com",
    "fast.wistia.com",
  ];

  const videoExtensions = [".mp4", ".mov", ".webm", ".ogg", ".m4v"];

  return (
    knownVideoHosts.includes(host) ||
    videoExtensions.some((extension) => path.endsWith(extension))
  );
};

export const isValidWebsiteUrl = (value: string) =>
  isValidHttpUrl(value) && !isValidVideoUrl(value);
